import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import {
    ArrowBackIcon,
    ArrowForwardIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
} from '@components/icons';

import styles from './SliderNavigation.module.scss';

type ButtonVariation = 'circle' | 'full' | 'circleWithChevron';
type ClassKey = 'button' | 'prev' | 'next';

const variationClassMap: Record<ButtonVariation, string> = {
    circle: styles.isCircleVariation,
    full: styles.isFullVariation,
    circleWithChevron: styles.isCircleWithChevronVariant,
};

type SliderNavigationProps = {
    onPrev(): void;
    onNext(): void;
    isPrevButtonEnabled?: boolean;
    isNextButtonEnabled?: boolean;
    variation?: ButtonVariation;
    classes?: Classes<ClassKey>;
};
export const SliderNavigation: FunctionComponent<SliderNavigationProps> = (props) => {
    const {
        onPrev,
        onNext,
        classes,
        isPrevButtonEnabled = true,
        isNextButtonEnabled = true,
        variation = 'circle',
    } = props;

    const buttonVariation = variationClassMap[variation];
    const baseButtonClasses = clsx(styles.button, buttonVariation, classes?.button);

    return (
        <>
            <button
                type="button"
                className={clsx(baseButtonClasses, styles.prev, classes?.prev)}
                onClick={onPrev}
                disabled={!isPrevButtonEnabled}
            >
                {variation !== 'circleWithChevron' && <ArrowBackIcon className={styles.icon} />}
                {variation === 'circleWithChevron' && <ChevronLeftIcon className={styles.icon} />}
            </button>
            <button
                type="button"
                className={clsx(baseButtonClasses, styles.next, classes?.next)}
                onClick={onNext}
                disabled={!isNextButtonEnabled}
            >
                {variation !== 'circleWithChevron' && <ArrowForwardIcon className={styles.icon} />}
                {variation === 'circleWithChevron' && <ChevronRightIcon className={styles.icon} />}
            </button>
        </>
    );
};
